/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Typography, Button, Row, Col, Breadcrumb, Tooltip, Modal, Spin, Space, Select, Segmented, Empty } from 'antd';
import * as AntDIcons from '@ant-design/icons';
import NoticeBoardSlide from '../../components/notice-board/NoticeBoardSlide';
import axios from 'axios';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';

const { Text } = Typography;
const { Option } = Select;

export function FormativeAssessmentSubjects() {
   const navigate = useNavigate();

   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);
   // const user_full_name = Utils.getCurrentUserInfo(Enums.UserInfo.fullname);

   const [userList, setUserList] = useState([]);
   const [questionTypeModalVisible, setQuestionTypeModalVisible] = useState(false);
   const [questionType, setQuestionType] = useState(1);

   const [subjectList, setSubjectList] = useState([]);
   // const [user_id, setUserId] = useState(Utils.getCurrentUserInfo(Enums.UserInfo.id));
   const [loading, setLoading] = useState(false);

   const [user_id, setUserId] = useState(localStorage.getItem('selected-teacher') ?? Utils.getCurrentUserInfo(Enums.UserInfo.id));
   const user_full_name = localStorage.getItem('selected-teacher-name') ?? Utils.getCurrentUserInfo(Enums.UserInfo.fullname);

   useEffect(() => {
      Utils.verifyJwt();

      if (user_role.toLowerCase() !== 'admin' && user_role.toLowerCase() !== 'teacher' && user_role.toLowerCase() !== 'co-teacher')
         navigate('/home');

      if (user_role.toLowerCase() === "admin") {
         var url = `${process.env.REACT_APP_API_LESSON}/listAllStaff`;
         axios.get(url).then((response) => {
            if (response.data) {
               let data = response.data;
               var users = data.filter((d) => d.id !== Number(user_id)).sort((a, b) => {
                  var aVal = a["first_Name"];
                  var bVal = b["first_Name"];
                  switch (typeof aVal) {
                     case 'string':
                        return aVal.localeCompare(bVal);
                     case 'number':
                        return aVal - bVal;
                     default:
                        throw new Error("Unsupported value to sort by");
                  }
               });
               var final = data.filter((d) => d.id === Number(user_id));
               Array.prototype.push.apply(final, users);
               setUserList(final);

            }
         }, (error) => {
            console.log(error.message);
         });
      }

      getSubjects(user_id);

   }, []);

   const getSubjects = (userid) => {
      setLoading(true);

      axios.get(`${process.env.REACT_APP_API_ASSESSMENT}/subjectgroup?id=${userid}&type=formative`).then((response) => {
         if (response.data) {
            setLoading(false);

            const data = response.data;
            var subjects = [];
            data.map((item) => {
               let obj = { 'value': item.id, 'name': item.subject_group }
               subjects.push(obj);
            });

            setSubjectList(subjects);
         }
      }, (error) => {
         setLoading(false);
         console.log(error.message);
      });
   }

   // function colorize() {
   //    var r = ('0' + (Math.random() * 255 | 0).toString(16)).slice(-2),
   //       g = ('0' + (Math.random() * 255 | 0).toString(16)).slice(-2),
   //       b = ('0' + (Math.random() * 255 | 0).toString(16)).slice(-2);
   //    return '#' + r + g + b;
   // }

   const itemSubjectClick = (subject, subjectname) => {
      navigate(`/formativeassessment?id=${subject}&name=${subjectname}&staff=${user_id}`);
   }

   const handleUserChange = (id) => {
      // localStorage.setItem('selected-teacher', id);
      var teacher = userList.find((item) => {
         return item.id === id;
      });
      localStorage.setItem('selected-teacher-name', teacher.first_Name.trim() + " " + teacher.last_Name.trim());
      localStorage.setItem('selected-teacher', id);
      setUserId(id);
      getSubjects(id);
   }

   const handleCreate = () => {
      setQuestionTypeModalVisible(false);

      if (questionType === 1) {
         navigate('/formativeassessment/create-pdf', { state: { type: "summative" } });
      } else if (questionType === 2) {
         navigate('/formativeassessment/create-manual', { state: { type: "summative" } });
      }
   };

   return (
      <>
         <NoticeBoardSlide />
         <div className="dashboard-area-all">
            <div className="dashboard-item">
               <div className="dashboard-item-inner">
                  <Breadcrumb separator=">" style={{ paddingBottom: '15px' }}>
                     <Breadcrumb.Item>
                        <Link to="/home">Home</Link>
                     </Breadcrumb.Item>
                     <Breadcrumb.Item>Brainee LMS</Breadcrumb.Item>
                     <Breadcrumb.Item>Formative Assessment</Breadcrumb.Item>
                  </Breadcrumb>
               </div>

               {
                  <Row gutter={12} style={{ paddingBottom: "15px" }}>
                     <Col className="gutter-row" span={12} style={{ textAlign: "left" }}>
                        <div className='search-columns-2'>
                           {user_role.toLowerCase() === 'admin' &&
                              <>
                                 <Space direction='horizontal' size={'small'}>
                                    <span>View as </span>
                                    <Select
                                       showSearch
                                       placeholder="Search to Select"
                                       optionFilterProp="children"
                                       // filterOption={(input, option) => option.children.includes(input)}
                                       defaultValue={user_full_name}
                                       style={{ width: '250px' }}
                                       onChange={(value) => handleUserChange(value)} >
                                       {
                                          userList.map((item) => {
                                             var fullname = (item.first_Name + " " + item.last_Name).trimEnd()
                                             return (
                                                <Option value={item.id}>{fullname}</Option>
                                             )
                                          })
                                       }
                                    </Select>
                                 </Space>
                              </>
                           }
                        </div>
                     </Col>
                     <Col className="gutter-row" span={12} style={{ textAlign: "right" }}>
                        <Tooltip placement="bottom" title='Create new Assessment'>
                           <Button className='button-shadow' type='primary' size='large' shape='round' style={{ maxWidth: '25ch' }} onClick={() => setQuestionTypeModalVisible(true)}>
                              <Text ellipsis style={{ color: "#fff" }}><AntDIcons.PlusOutlined />&nbsp;Create Formative</Text>
                           </Button>
                        </Tooltip>
                     </Col>
                  </Row>
               }

               {
                  loading
                     ?
                     <div className='center-empty-space'>
                        <Spin size='large' tip="Loading, please wait..." />
                     </div>
                     :
                     subjectList.length > 0
                        ?
                        <div className="ag-format-container">
                           <div className="ag-courses_box">
                              {
                                 // !questionTypeModalVisible &&
                                 subjectList.map((subject, i) => {
                                    var color = Utils.colorize();

                                    return (
                                       <>
                                          <div className="ag-courses_item">
                                             <a href="#" className="ag-courses-item_link">
                                                <div className="ag-courses-item_bg" style={{ backgroundColor: color }} onClick={() => itemSubjectClick(subject.value, subject.name)}></div>
                                                <div className="ag-courses-item_title" onClick={() => itemSubjectClick(subject.value, subject.name)}>
                                                   <Tooltip placement="top" title={subject.name}>
                                                      {subject.name}
                                                   </Tooltip>
                                                </div>
                                             </a>
                                          </div>
                                       </>
                                    )
                                 })
                              }
                           </div>
                        </div>
                        :
                        <div className='center-empty-space'>
                           <Empty image="../../images/brainee_mascot.png" description="No records found." />
                        </div>
               }
            </div>
         </div>

         <Modal
            title="Select Questionaire Option"
            centered
            destroyOnClose={true}
            open={questionTypeModalVisible}
            onOk={() => handleCreate()}
            onCancel={() => setQuestionTypeModalVisible(false)}
            cancelButtonProps={{ shape: "round" }}
            okButtonProps={{ shape: "round" }}
            width={"300px"}
         >
            <Segmented
               key={'uid'}
               value={questionType}
               block
               options={[
                  {
                     label: 'Upload',
                     value: 1,
                  },
                  {
                     label: 'Create',
                     value: 2,
                  },
               ]}
               onChange={(val) => setQuestionType(val)}
            />
            <div style={{ display: 'flex', justifyContent: 'center', width: '100%', paddingTop: '20px' }}>
               <Text strong>
                  {
                     questionType === 1
                        ?
                        'Upload a pdf format questionaire'
                        :
                        'Use Brainee assessment tools'
                  }
               </Text>
            </div>
         </Modal>
      </>
   )
}